import React, { Component } from 'react'
import AuthenticationService from './AuthenticationService.js'

class LogoutComponent extends Component {

    componentDidMount() {
        this.props.setUserLoggedIn('')
    }

    render() {
        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(24px); }
                        to   { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes float {
                        0%, 100% { transform: translateY(0px); }
                        50%       { transform: translateY(-10px); }
                    }
                    @keyframes pulse-ring {
                        0%   { box-shadow: 0 0 0 0 rgba(59,130,246,0.4); }
                        70%  { box-shadow: 0 0 0 16px rgba(59,130,246,0); }
                        100% { box-shadow: 0 0 0 0 rgba(59,130,246,0); }
                    }
                    @keyframes particles {
                        0%   { transform: translateY(100vh) scale(0.8); opacity: 0; }
                        8%   { opacity: 1; }
                        92%  { opacity: 0.6; }
                        100% { transform: translateY(-100px) scale(1.1); opacity: 0; }
                    }

                    .logout-card {
                        animation: fadeInUp 0.7s ease forwards;
                        font-family: 'Inter', sans-serif;
                    }
                    .logout-particle {
                        position: absolute;
                        border-radius: 50%;
                        animation: particles linear infinite;
                        pointer-events: none;
                    }
                    .logout-icon-wrap {
                        animation: float 3s ease-in-out infinite;
                    }
                    .logout-btn {
                        width: 100%;
                        padding: 14px;
                        background: linear-gradient(135deg, #2563eb, #3b82f6);
                        border: none;
                        border-radius: 10px;
                        color: white;
                        font-family: 'Inter', sans-serif;
                        font-size: 0.88rem;
                        font-weight: 600;
                        letter-spacing: 1.5px;
                        text-transform: uppercase;
                        cursor: pointer;
                        transition: all 0.25s;
                        box-shadow: 0 4px 16px rgba(59,130,246,0.35);
                    }
                    .logout-btn:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 24px rgba(59,130,246,0.5);
                        animation: pulse-ring 1.5s ease infinite;
                    }
                `}</style>

                {/* Partículas — 35 como el Login */}
                {[...Array(35)].map((_, i) => {
                    const size = 1.5 + Math.random() * 4
                    const colorPick = Math.random()
                    const bg = colorPick < 0.5
                        ? `rgba(59,130,246,${0.3 + Math.random() * 0.5})`
                        : colorPick < 0.75
                            ? `rgba(99,179,237,${0.25 + Math.random() * 0.4})`
                            : `rgba(147,197,253,${0.2 + Math.random() * 0.35})`
                    return (
                        <div key={i} className="logout-particle" style={{
                            left: `${Math.random() * 100}%`,
                            width: `${size}px`,
                            height: `${size}px`,
                            background: bg,
                            boxShadow: size > 4 ? `0 0 ${size * 2}px ${bg}` : 'none',
                            animationDuration: `${7 + Math.random() * 13}s`,
                            animationDelay: `${Math.random() * 10}s`,
                        }} />
                    )
                })}

                {/* Grid */}
                <div style={styles.grid} />

                <div className="logout-card" style={styles.card}>

                    {/* Icono */}
                    <div style={styles.iconWrap}>
                        <img
                            src="/pshm6spshm6spshm.png"
                            alt="BDC"
                            className="logout-icon-wrap"
                            style={{ width: 180, height: 180, objectFit: 'contain', mixBlendMode: 'screen', filter: 'drop-shadow(0 0 20px rgba(59,130,246,0.5))' }}
                            onError={(e) => { e.target.style.display='none'; e.target.parentNode.innerHTML='💀' }}
                        />
                    </div>

                    {/* Texto */}
                    <div style={styles.textWrap}>
                        <h1 style={styles.title}>¡Hasta pronto!</h1>
                        <div style={styles.titleBar} />
                        <p style={styles.subtitle}>Sesión cerrada correctamente</p>
                        <p style={styles.desc}>Gracias por usar <strong style={{color: 'white'}}>Cloud  Zenyth</strong>. Tu sesión ha sido cerrada de forma segura.</p>
                    </div>

                    {/* Separador */}
                    <div style={styles.divider} />

                    {/* Botón */}
                    <button
                        className="logout-btn"
                        onClick={() => this.props.history.push('/login')}
                    >
                        Volver a ingresar
                    </button>

                    <p style={styles.footer}>© 2026 Cloud Zenyth by KrvheD</p>
                </div>
            </div>
        )
    }
}

const styles = {
    root: {
        minHeight: '100vh',
        backgroundImage: 'url(/High-Res.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: "'Inter', sans-serif",
    },
    grid: {
        position: 'absolute', inset: 0,
        backgroundImage: `
            linear-gradient(rgba(59,130,246,0.05) 1px, transparent 1px),
            linear-gradient(90deg, rgba(59,130,246,0.05) 1px, transparent 1px)
        `,
        backgroundSize: '60px 60px',
        pointerEvents: 'none',
    },
    card: {
        background: 'linear-gradient(145deg, rgba(10,15,30,0.72), rgba(15,23,42,0.80))',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(59,130,246,0.25)',
        borderRadius: '20px',
        padding: '44px 38px 34px',
        width: '100%',
        maxWidth: '400px',
        position: 'relative',
        zIndex: 10,
        boxShadow: '0 25px 80px rgba(0,0,0,0.5), inset 0 1px 0 rgba(59,130,246,0.15)',
        textAlign: 'center',
    },
    iconWrap: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '20px',
    },

    textWrap: {
        marginBottom: '24px',
    },
    title: {
        fontFamily: "'Inter', sans-serif",
        fontSize: '1.6rem',
        fontWeight: '700',
        color: 'white',
        margin: '0 0 8px',
        letterSpacing: '2px',
    },
    titleBar: {
        width: '40px', height: '2px',
        background: 'linear-gradient(90deg, transparent, #3b82f6, transparent)',
        margin: '0 auto 12px',
        borderRadius: '2px',
    },
    subtitle: {
        color: 'rgba(148,163,184,0.7)',
        fontSize: '0.72rem',
        letterSpacing: '3px',
        textTransform: 'uppercase',
        margin: '0 0 14px',
    },
    desc: {
        color: 'rgba(148,163,184,0.6)',
        fontSize: '0.85rem',
        lineHeight: 1.6,
        margin: 0,
    },
    divider: {
        height: 1,
        background: 'rgba(59,130,246,0.15)',
        margin: '0 0 22px',
    },
    footer: {
        textAlign: 'center',
        color: 'rgba(255,255,255,0.12)',
        fontSize: '0.68rem',
        marginTop: '16px',
        marginBottom: 0,
    },
}

export default LogoutComponent
